import { Flex } from 'antd';
import DefaultButton from '@src/components/ui-kit/buttons/DefaultButton';
import { codeCircle, cloud, stars } from './svgs';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import styles from './agent-sections.module.css';

const CREATE_AI_AVATAR_SECTION_ID = 'create-ai-avatar';

export default function FirstSection() {
  function handleTryNow() {
    const section = document.getElementById(CREATE_AI_AVATAR_SECTION_ID);

    if (!section) {
      return;
    }

    const sectionTop = section.offsetTop;
    window.scrollTo({
      top: sectionTop - 150,
      behavior: 'smooth',
    });
  }

  return (
    <div className={styles.firstSectionRoot} data-cy='agent3d-first-section'>
      <img
        className={styles.firstSectionBackground}
        src={`${WEBSITE_PUBLIC_CDN}/agent-3d-first-section-bg.png`}
        alt='First section background'
      />
      <img
        className={styles.firstSectionManPic}
        src={`${WEBSITE_PUBLIC_CDN}/agent-3d-man-pic.png`}
        alt='Man picture'
      />
      <img
        className={styles.firstSectionGirlPic}
        src={`${WEBSITE_PUBLIC_CDN}/agent-3d-girl-pic.png`}
        alt='Woman picture'
      />
      <div className={styles.darkFilter} />
      <Flex
        vertical
        align='center'
        justify='center'
        className={styles.firstSectionContent}
      >
        <div className={styles.firstSectionTitle}>
          AGENT 3D<span className={styles.firstSectionTM}>™</span>
        </div>
        <p className={styles.firstSectionDescription}>
          Fastest and most efficient way to customize and deploy AI 3D
          characters anywhere on the web
        </p>
        <Flex
          vertical
          align='center'
          justify='center'
          className={styles.firstSectionFeatures}
        >
          <Flex className={styles.firstSectionFeaturesContent}>
            <Flex
              justify='center'
              align='center'
              className={styles.firstSectionFeature}
            >
              {codeCircle} No coding required
            </Flex>
            <Flex
              justify='center'
              align='center'
              className={styles.firstSectionFeature}
            >
              {stars} AI-driven interactions
            </Flex>
            <Flex
              justify='center'
              align='center'
              className={styles.firstSectionFeature}
            >
              {cloud} Web-ready deployment
            </Flex>
          </Flex>
          <DefaultButton onClick={handleTryNow}>Try now</DefaultButton>
        </Flex>
      </Flex>
    </div>
  );
}
